import { render, staticRenderFns } from "./partnersItem.vue?vue&type=template&id=9b5b0146&scoped=true&"
import script from "./partnersItem.vue?vue&type=script&lang=js&"
export * from "./partnersItem.vue?vue&type=script&lang=js&"
import style0 from "./partnersItem.vue?vue&type=style&index=0&id=9b5b0146&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b5b0146",
  null
  
)

export default component.exports